/* Reef Lagoon — Caught. Painted. Worn. reveal.
 * On scroll into view, fade-up each [data-rcpw-reveal] element (stagger = its
 * data index * 150ms within each group) and draw the spine (scaleY 0 -> 1) on the
 * stages container's first intersection. Gated behind prefers-reduced-motion
 * (reduced = final state, no motion — CSS default is fully visible/drawn).
 * Runs on load and on the theme editor's shopify:section:load. Idempotent. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.rcpwInit === '1') return;
    root.dataset.rcpwInit = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return; // CSS default is the final state — nothing to animate

    root.classList.add('rcpw--observe');

    var reveals = root.querySelectorAll('[data-rcpw-reveal]');
    var stages = root.querySelector('[data-rcpw-stages]');
    var spine = root.querySelector('[data-rcpw-spine]');

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < reveals.length; i++) reveals[i].classList.add('is-in');
      if (spine) spine.classList.add('is-drawn');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var idx = parseInt(e.target.getAttribute('data-rcpw-reveal'), 10) || 0;
        window.setTimeout(function () { e.target.classList.add('is-in'); }, idx * 150);
        io.unobserve(e.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    for (var k = 0; k < reveals.length; k++) io.observe(reveals[k]);

    if (stages && spine) {
      var spineIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          spine.classList.add('is-drawn');
          spineIO.disconnect();
        });
      }, { threshold: 0.05 });
      spineIO.observe(stages);
    }
  }

  function initAll() {
    var els = document.querySelectorAll('.rcpw');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('.rcpw') : null;
    if (el) { init(el); } else { initAll(); }
  });
})();
